module.exports = __webpack_public_path__ + "static/media/home-1.66553f05.mp4";